import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.jpeg";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.jpeg";
import projImg8 from "../assets/img/project-img8.png";
import projImg9 from "../assets/img/project-img9.jpeg";

import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "ENS on Polygon ",
      description: "NFT Dapp to Mint Domains",
      imgUrl: projImg1,
      targetURL:
        "https://stackoverflow.com/questions/66330851/how-to-redirect-when-clicked-on-carousel-images-in-react",
    },
    {
      title: "NFT Battle Game",
      description:
        "Game with NFT based Character that loose/gain trait while battling",
      imgUrl: projImg2,
    },
    {
      title: " Staking DApp",
      description: "Earn Interest on your deposit",
      imgUrl: projImg3,
    },
  ];

  const smart = [
    {
      title: "Staking Smart Contract ",
      description: "Gives ether as interest on your deposit at fixed APY",
      imgUrl: projImg4,
    },
    {
      title: "MultiSig Wallet",
      description:
        "A wallet that requires multiple approvals for any transaction ",
      imgUrl: projImg5,
    },
    {
      title: "ENS on Polygon",
      description:
        "Deployed Domain Contract on Polygon Testnet that contains your domain as NFT which you can render via OpenSea testnet",
      imgUrl: projImg6,
    },
    {
      title: "Battle Game Contract",
      description:
        "Used OpenZeppelin Libraries , Base64 to create a dynamic contract where NFT's trait updates due to your ingame action , with minting function ",
      imgUrl: projImg7,
    },
    {
      title: "Crowd Funding Contract",
      description:
        "People can pool the desired amount set by the deployer of the contract",
      imgUrl: projImg8,
    },
    {
      title: "Dutch Auction Contract",
      description:
        "Developed dutch auction contract where the price of an NFT reduces at certain percent defined in the contract by the owner/deployer of the contract",
      imgUrl: projImg9,
    },
  ];

  return (
    <section className='project' id='project'>
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Here are a bunch of projects developed by me . All of them
                    can be accessed by clicking on "My Work" tab above.
                  </p>

                  <Tab.Container id='projects-tabs' defaultActiveKey='first'>
                    <Nav
                      variant='pills'
                      className='nav-pills mb-5 justify-content-center align-items-center'
                      id='pills-tab'
                    >
                      <Nav.Item>
                        <Nav.Link eventKey='first'>DApps</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='second'>Smart contract</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='third'>Get in Touch</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id='slideInUp'
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey='first'>
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey='second'>
                        <Row>
                          {smart.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey='third'>
                        <p>
                          Yes! I am always excited about any new opportunities
                          or ideas. My inbox is always open. Whether you want to
                          work with me, have a question or want to say hi, I’ll
                          try my best to get back to you!
                          <br></br>Email: ranjanrishi504@gmail.com
                          <br></br> Contact : +916200063243
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className='background-image-right' src={colorSharp2}></img>
    </section>
  );
};
